import {
  APPOINTMENT_TYPES_TRANSLATION,
  LEGEND_TYPES,
} from '@shared/data-access'
import {
  CalendarAdd,
  RequestQuote,
  Home,
  Phone,
  NonCertified,
  UpdateNow,
  ToolBox,
  Badge,
} from '@carbon/icons-react'
import { Images } from '@shared/assets'

const CarIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
    <path d="M12.8363 6.97375L9.45438 5.7575L8.03688 3.98125C7.91385 3.83092 7.75899 3.70977 7.58346 3.62655C7.40794 3.54333 7.21613 3.50011 7.02187 3.5H3.52188C3.30837 3.5011 3.09835 3.55428 2.91004 3.65491C2.72173 3.75555 2.56081 3.9006 2.44125 4.0775L1.25562 5.8275C1.01002 6.18739 0.877481 6.61242 0.875 7.04813V10.5C0.875 10.616 0.921094 10.7273 1.00314 10.8094C1.08519 10.8914 1.19647 10.9375 1.3125 10.9375H2.24875C2.3495 11.3082 2.56944 11.6355 2.87464 11.8688C3.17983 12.1021 3.55333 12.2286 3.9375 12.2286C4.32167 12.2286 4.69517 12.1021 5.00036 11.8688C5.30556 11.6355 5.5255 11.3082 5.62625 10.9375H8.37375C8.4745 11.3082 8.69444 11.6355 8.99964 11.8688C9.30483 12.1021 9.67833 12.2286 10.0625 12.2286C10.4467 12.2286 10.8202 12.1021 11.1254 11.8688C11.4306 11.6355 11.6505 11.3082 11.7513 10.9375H12.6875C12.8035 10.9375 12.9148 10.8914 12.9969 10.8094C13.0789 10.7273 13.125 10.616 13.125 10.5V7.385C13.125 7.29509 13.0972 7.20737 13.0456 7.13379C12.9939 7.0602 12.9208 7.00432 12.8363 6.97375ZM3.9375 11.375C3.76444 11.375 3.59527 11.3237 3.45138 11.2275C3.30748 11.1314 3.19533 10.9947 3.12911 10.8348C3.06288 10.675 3.04555 10.499 3.07931 10.3293C3.11307 10.1596 3.19641 10.0037 3.31878 9.88128C3.44115 9.75891 3.59706 9.67557 3.7668 9.64181C3.93653 9.60805 4.11246 9.62538 4.27235 9.69161C4.43223 9.75783 4.56889 9.86998 4.66504 10.0139C4.76118 10.1578 4.8125 10.3269 4.8125 10.5C4.8125 10.7321 4.72031 10.9546 4.55622 11.1187C4.39212 11.2828 4.16956 11.375 3.9375 11.375ZM10.0625 11.375C9.88944 11.375 9.72027 11.3237 9.57638 11.2275C9.43248 11.1314 9.32033 10.9947 9.25411 10.8348C9.18788 10.675 9.17055 10.499 9.20431 10.3293C9.23808 10.1596 9.32141 10.0037 9.44378 9.88128C9.56615 9.75891 9.72206 9.67557 9.8918 9.64181C10.0615 9.60805 10.2375 9.62538 10.3973 9.69161C10.5572 9.75783 10.6939 9.86998 10.79 10.0139C10.8862 10.1578 10.9375 10.3269 10.9375 10.5C10.9375 10.7321 10.8453 10.9546 10.6812 11.1187C10.5171 11.2828 10.2946 11.375 10.0625 11.375ZM12.25 10.0625H11.7513C11.6505 9.69178 11.4306 9.3645 11.1254 9.13118C10.8202 8.89785 10.4467 8.77144 10.0625 8.77144C9.67833 8.77144 9.30483 8.89785 8.99964 9.13118C8.69444 9.3645 8.4745 9.69178 8.37375 10.0625H5.62625C5.5255 9.69178 5.30556 9.3645 5.00036 9.13118C4.69517 8.89785 4.32167 8.77144 3.9375 8.77144C3.55333 8.77144 3.17983 8.89785 2.87464 9.13118C2.56944 9.3645 2.3495 9.69178 2.24875 10.0625H1.75V7.04813C1.74983 6.78441 1.82911 6.52676 1.9775 6.30875L3.16313 4.55875C3.20424 4.50099 3.25876 4.45409 3.32202 4.42208C3.38528 4.39007 3.45536 4.37392 3.52625 4.375H7.02625C7.09052 4.3749 7.15403 4.38895 7.21225 4.41618C7.27048 4.4434 7.32199 4.48311 7.36312 4.5325L8.85063 6.40062C8.90193 6.46281 8.96816 6.51098 9.04313 6.54062L12.25 7.69125V10.0625Z" fill="#F5F5F5"/>
  </svg>
)

export const LEGEND_ONE = Object.freeze([
  LEGEND_TYPES.initialReportOnline,
  LEGEND_TYPES.initialReportFaceToFace,
  LEGEND_TYPES.welcomeCall,
  LEGEND_TYPES.initialAnalysisCall,
  LEGEND_TYPES.initialAnalysisOnline,
  LEGEND_TYPES.initialAnalysisFaceToFace,
  LEGEND_TYPES.absences,
])

export const LEGEND_TWO = Object.freeze([
  LEGEND_TYPES.consultation,
  LEGEND_TYPES.followUpCall,
  LEGEND_TYPES.service,
  LEGEND_TYPES.genericAnalysis,
  LEGEND_TYPES.yearlyFollowUpCall,
  LEGEND_TYPES.yearlyFollowUpOnline,
  LEGEND_TYPES.travelTime,
])

export const LEGEND_TRANSLATIONS = Object.freeze({
  [LEGEND_TYPES.initialReportOnline]: 'agenda.legend.initialReportOnline',
  [LEGEND_TYPES.initialReportFaceToFace]:
    'agenda.legend.initialReportFaceToFace',
  [LEGEND_TYPES.welcomeCall]:
    APPOINTMENT_TYPES_TRANSLATION[LEGEND_TYPES.welcomeCall],
  [LEGEND_TYPES.initialAnalysisCall]: 'agenda.legend.initialAnalysisCall',
  [LEGEND_TYPES.initialAnalysisOnline]: 'agenda.legend.initialAnalysisAIOnline',
  [LEGEND_TYPES.initialAnalysisFaceToFace]:
    'agenda.legend.initialAnalysisAIFaceToFace',
  [LEGEND_TYPES.absences]: APPOINTMENT_TYPES_TRANSLATION[LEGEND_TYPES.absences],
  [LEGEND_TYPES.consultation]:
    APPOINTMENT_TYPES_TRANSLATION[LEGEND_TYPES.consultation],
  [LEGEND_TYPES.followUpCall]:
    APPOINTMENT_TYPES_TRANSLATION[LEGEND_TYPES.followUpCall],
  [LEGEND_TYPES.service]: APPOINTMENT_TYPES_TRANSLATION[LEGEND_TYPES.service],
  [LEGEND_TYPES.genericAnalysis]:
    APPOINTMENT_TYPES_TRANSLATION[LEGEND_TYPES.genericAnalysis],
  [LEGEND_TYPES.yearlyFollowUp]:
    APPOINTMENT_TYPES_TRANSLATION[LEGEND_TYPES.yearlyFollowUp],
  [LEGEND_TYPES.yearlyFollowUpCall]: 'appointmentType.yearlyFollowUpCall',
  [LEGEND_TYPES.yearlyFollowUpOnline]: 'appointmentType.yearlyFollowUpOnline',
  [LEGEND_TYPES.travelTime]: 'agenda.legend.travelTime',
})

const InitialReportIcon = ({ width, height }) => (
  <Images.InitialReport width={width} height={height} />
)

export const LEGEND_ICONS = Object.freeze({
  [LEGEND_TYPES.initialReportOnline]: <CalendarAdd size={16} />,
  [LEGEND_TYPES.initialReportFaceToFace]: <Home size={16} />,
  [LEGEND_TYPES.welcomeCall]: <Phone size={16} />,
  [LEGEND_TYPES.initialAnalysisCall]: (
    <InitialReportIcon width={16} height={16} />
  ),
  [LEGEND_TYPES.initialAnalysisOnline]: (
    <InitialReportIcon width={16} height={16} />
  ),
  [LEGEND_TYPES.initialAnalysisFaceToFace]: (
    <InitialReportIcon width={16} height={16} />
  ),
  [LEGEND_TYPES.absences]: <NonCertified size={16} />,
  [LEGEND_TYPES.consultation]: <RequestQuote size={16} />,
  [LEGEND_TYPES.followUpCall]: <UpdateNow size={16} />,
  [LEGEND_TYPES.service]: <ToolBox size={16} />,
  [LEGEND_TYPES.genericAnalysis]: <Badge size={16} />,
  [LEGEND_TYPES.yearlyFollowUpCall]: (
    <InitialReportIcon width={16} height={16} />
  ),
  [LEGEND_TYPES.yearlyFollowUpOnline]: (
    <InitialReportIcon width={16} height={16} />
  ),
  [LEGEND_TYPES.travelTime]: <CarIcon />,
})
